export const RESEND_SALES_INVOICE = gql`
    mutation ResendSalesInvoice($input: ResendSalesInvoiceInput) {
        resendSalesInvoice(input: $input) {
            id
        }
    }
`;
